var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    directives: [{ name: "copy-text", rawName: "v-copy-text" }],
    domProps: { innerHTML: _vm._s(_vm.rowData[_vm.fieldData.fieldCode]) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }